const selectorFactory =
  (walletAccountSelector, createAssetSourceIncomingOrdersAmount) => (assetName) => (state) =>
    createAssetSourceIncomingOrdersAmount({
      assetName,
      walletAccount: walletAccountSelector(state),
    })(state)

const createAssetIncomingOrdersAmountSelectorDefinition = {
  id: 'createAssetIncomingOrdersAmount',
  selectorFactory,
  dependencies: [
    { module: 'walletAccounts', selector: 'active' },
    { selector: 'createAssetSourceIncomingOrdersAmount' },
  ],
}

export default createAssetIncomingOrdersAmountSelectorDefinition
